export const es = {
  nav_experiences: "Experiencias",
  nav_destinations: "Destinos",
  nav_boat: "Capri y las Islas",
  nav_taste: "Sabor",
  nav_stay: "Estancias",
  nav_create: "Crea tu experiencia",
  nav_book: "Reserva tu experiencia",
  sign_in: "Acceder",
  sign_out: "Salir",
  account_greeting: "Hola",
  tagline: "Descubre Campania. Vive la experiencia.",
  hero_line1: "Vive la tierra donde el Mediterráneo ",
  hero_line2: "se encuentra con el fuego.",
  hero_cta1: "Descubre las experiencias",
  hero_cta2: "Personaliza tu tour",
  dim_title: "¿Qué quieres vivir?",
  dim_sea: "MAR",
  dim_sea_desc: "Mar, islas, barcos, canoas, costas y atardeceres.",
  dim_culture: "CULTURA",
  dim_culture_desc: "Arqueología, historia, arte, pueblos y patrimonio.",
  dim_nature: "NATURALEZA",
  dim_nature_desc: "Volcanes, montañas, senderos y actividades al aire libre.",
  dim_taste: "SABOR",
  dim_taste_desc: "Vino, cocina, productos locales y tradiciones gastronómicas.",
  explore_title: "Explora Campania",
  explore_sub: "De los Campos Flégreos a Nápoles, de las islas al Vesubio, de la Costa a los Apeninos.",
  featured_title: "Experiencias destacadas",
  featured_sub: "Las experiencias más queridas, seleccionadas por nuestro equipo.",
  bysea_title: "Flegrea by Sea",
  bysea_sub: "Mira Campania desde otra perspectiva.",
  bysea_cta: "Descubrir experiencias en barco",
  taste_title: "Taste Campania",
  taste_sub: "Un viaje por los sabores de Campania.",
  taste_cta: "Descubrir experiencias de sabor",
  beyond_title: "Beyond the Coast",
  beyond_sub: "Descubre el lado salvaje de Campania.",
  beyond_cta: "Descubrir experiencias de naturaleza",
  create_title: "¿No encuentras lo que buscas?",
  create_sub: "Construyamos juntos tu experiencia: tours privados, familias, parejas, grupos, empresas, propuestas románticas, gastronomía y mar.",
  create_cta: "Crea tu tour",
  stay_title: "Stay With Us",
  stay_sub: "B&B y residencias seleccionadas: la base ideal para vivir el territorio.",
  stay_cta: "Descubrir estancias",
  why_title: "¿Por qué Flegrea Experience?",
  why_1: "Conocemos el territorio más allá de las guías",
  why_2: "Experiencias auténticas, no simples visitas",
  why_3: "Grupos pequeños: más tiempo, más atención",
  why_4: "Flexibilidad: adaptamos la experiencia a ti",
  why_5: "Colaboramos con profesionales y realidades locales",
  stories_title: "Una tierra que contar",
  stories_sub: "Mitos, erupciones y emperadores: las historias de los Campos Flégreos, contadas por quienes viven aquí.",
  final_title: "Tu historia en Campania empieza aquí",
  final_sub: "Elige una experiencia, añade lo que te gusta, o déjanos crearla por ti.",
  copy_1: "Campania es más que un destino.",
  copy_2: "Es ciudades antiguas, paisajes volcánicos, islas mediterráneas, pueblos escondidos, senderos de montaña, comida extraordinaria e historias que han sobrevivido siglos.",
  copy_3: "Flegrea Experience nació para ayudarte a vivirlo todo.",
  copy_4: "De los Campos Flégreos a Nápoles, de Procida e Isquia a Pompeya, de la Costa Amalfitana a las montañas que limitan con Abruzzo y Molise.",
  copy_5: "Elige una experiencia. Añade lo que amas. O deja que la creemos por ti.",
  copy_cta: "Descubre Campania",
  exp_page_title: "Experiencias",
  exp_page_sub: "Experiencias seleccionadas en toda Campania. Elige la tuya o combínala con nuestros extras gastronómicos.",
  filter_all: "Todas",
  filter_culture: "Cultura e Historia",
  filter_sea: "Mar e Islas",
  filter_canoe: "Canoa y Agua",
  filter_nature: "Naturaleza y Outdoor",
  filter_food: "Comida",
  filter_wine: "Vino",
  filter_night: "De noche",
  filter_private: "Privado",
  offer_badge: "-10%",
  launch_offer: "Oferta de lanzamiento — precio completo tachado",
  all_destinations: "Todos los destinos",
  results: "experiencias",
  from: "desde",
  per_person: "por persona",
  price_note: "Precios orientativos, a confirmar en la reserva.",
  discover: "Descubre la experiencia",
  the_experience: "La experiencia",
  highlights: "Puntos fuertes",
  included: "Incluido",
  not_included: "No incluido",
  addons_title: "Make It Taste Better",
  addons_sub: "Añade un sabor de Campania a tu experiencia.",
  addons_price_each: "por persona",
  on_request: "Bajo petición",
  meet_guide: "Tu guía",
  meet_guide_text: "Cada experiencia está guiada por guías certificados y profesionales locales seleccionados por Flegrea Experience. El conocimiento marca la diferencia.",
  good_to_know: "Conviene saber",
  gtk_1: "Las actividades al aire libre dependen de las condiciones meteorológicas y del mar.",
  gtk_2: "El punto de encuentro y la logística se comparten tras la reserva.",
  gtk_3: "Las experiencias privadas se pueden personalizar bajo petición.",
  faq_title: "FAQ",
  faq_q1: "¿En qué idiomas están disponibles las experiencias?",
  faq_a1: "Todas las experiencias están disponibles en italiano e inglés. Otros idiomas bajo petición.",
  faq_q2: "¿Cómo funciona la reserva?",
  faq_a2: "Contáctanos por WhatsApp o con el formulario: confirmamos disponibilidad y detalles y reservamos tu experiencia. En esta fase no se requiere pago online.",
  faq_q3: "¿Puedo personalizar una experiencia?",
  faq_a3: "Sí. Cada experiencia puede enriquecerse con extras gastronómicos, traslados y servicios adicionales, o crearse desde cero con 'Crea tu experiencia'.",
  book_now: "Reservar ahora",
  request_quote: "Pedir presupuesto",
  duration: "Duración",
  group_size: "Participantes",
  location_label: "Lugar",
  languages_label: "Idiomas",
  starting_price: "Precio inicial",
  dest_page_title: "Destinos",
  dest_page_sub: "Campania organizada por territorios: elige dónde, luego cómo vivirlo.",
  dest_experiences: "Experiencias en este destino",
  view_destination: "Explorar",
  boat_page_sub: "Mira Campania desde otra perspectiva.",
  boat_departure: "Salida",
  whats_included: "Qué incluye",
  book_boat: "Reserva tu experiencia en el mar",
  taste_page_sub: "Un viaje por los sabores de Campania.",
  make_taste: "Make It Taste Better",
  make_taste_sub: "Añade un sabor de Campania a tu experiencia. Casi todas las experiencias pueden enriquecerse con un momento gastronómico.",
  territories_title: "Territorios del sabor",
  stay_page_sub: "No simples hoteles: bases ideales para vivir el territorio, con experiencias a la puerta.",
  check_availability: "Comprobar disponibilidad",
  rooms_label: "Habitaciones",
  services_label: "Servicios",
  nearby_exp: "Experiencias cercanas",
  stay_placeholder_note: "Alojamiento seleccionado — detalles y disponibilidad en preparación.",
  step1: "¿Con quién viajas?",
  step2: "¿Cuántos?",
  step3: "¿Cuándo?",
  step4: "¿Qué te gusta?",
  step5: "¿Dónde?",
  step6: "¿Algo especial?",
  step7: "Cuéntanos más",
  step8: "Contacto",
  opt_solo: "Solo",
  opt_couple: "Pareja",
  opt_family: "Familia",
  opt_friends: "Amigos",
  opt_group: "Grupo",
  more_than_10: "Más de 10 (petición personalizada)",
  next: "Continuar",
  back: "Atrás",
  submit: "Crear mi experiencia",
  thankyou: "Gracias. Tu experiencia en Campania empieza aquí.",
  thankyou_sub: "Hemos recibido tu petición. Te contactaremos en breve para crear tu experiencia.",
  thankyou_wa: "Acelera todo por WhatsApp",
  name_label: "Nombre",
  email_label: "Email",
  phone_label: "Teléfono",
  whatsapp_label: "WhatsApp",
  notes_placeholder: "Cuéntanos qué sueñas: ocasiones especiales, ritmo, imprescindibles, necesidades particulares...",
  footer_experiences: "Experiencias",
  footer_legal: "Legal",
  footer_contacts: "Contactos",
  footer_follow: "Síguenos",
  privacy: "Privacidad",
  cookie: "Cookies",
  terms: "Términos y Condiciones",
  wa_float: "Planifica tu experiencia",
  wa_message: "¡Hola Flegrea Experience! Me gustaría información sobre:",
  wa_book_prefix: "¡Hola! Quiero reservar la experiencia:",
  wa_quote_prefix: "¡Hola! Quiero un presupuesto para la experiencia:",
  wa_stay_prefix: "¡Hola! Quiero comprobar disponibilidad de:",
  badge_PRIVATE: "Privado",
  badge_SMALL_GROUP: "Grupo pequeño",
  badge_SUMMER: "Verano",
  badge_BOAT: "Barco",
  badge_FOOD: "Sabor",
  badge_NATURE: "Naturaleza",
  loading: "Cargando...",
  not_found: "Experiencia no encontrada",
  back_experiences: "Todas las experiencias",
  back_destinations: "Todos los destinos",
  about: "Nosotros",
  contact: "Contacto",
  faq: "FAQ",
  nature_word: "Naturaleza",
  step_of: "de",
  date_flexible: "Mis fechas son flexibles",
  map_hint: "Explora el mapa — pasa el cursor sobre los lugares",
  choose_date: "Fecha",
  participants: "Participantes",
  time_slot: "Franja horaria",
  slot_morning: "Mañana",
  slot_afternoon: "Tarde",
  slot_evening: "Noche",
  addons_label: "Servicios adicionales",
  estimated_total: "Total estimado",
  send_request: "Enviar solicitud de reserva",
  whatsapp_context: "Reservar por WhatsApp",
  ask_questions: "¿Dudas? Escríbenos",
  save_experience: "Guardar experiencia",
  saved_favorite: "Experiencia guardada",
  removed_favorite: "Eliminada de guardadas",
  login_to_save: "Accede para guardar y gestionar tus experiencias",
  request_sent: "Solicitud enviada",
  request_sent_sub: "Hemos recibido tu solicitud. Te contactaremos en breve para confirmar disponibilidad y detalles.",
  remove: "Eliminar",
  account_title: "Mi cuenta",
  account_signin_sub: "Accede para ver tus solicitudes y experiencias guardadas.",
  my_requests: "Mis solicitudes",
  my_experiences: "Mis experiencias",
  no_requests: "Aún no has enviado solicitudes.",
  no_favorites: "Aún no has guardado ninguna experiencia.",
  discover_experiences: "Descubrir experiencias",
  custom_request: "Petición personalizada",
  requested_on: "Solicitado el",
  status_inviata: "Solicitud enviada",
  status_attesa: "Pendiente de confirmación",
  status_confermata: "Confirmada",
  status_completata: "Completada",
  status_annullata: "Cancelada",
  cookie_banner_text: "Usamos cookies técnicas necesarias y, solo con tu consentimiento, cookies analíticas para mejorar la experiencia. Puedes cambiar tu elección en cualquier momento.",
  cookie_accept_all: "Aceptar todas",
  cookie_reject: "Rechazar",
  cookie_customize: "Personalizar",
  cookie_save_prefs: "Guardar preferencias",
  cookie_necessary: "Cookies necesarias (siempre activas)",
  cookie_analytics: "Cookies analíticas",
  manage_cookies: "Gestionar preferencias de cookies",
  search_placeholder: "Buscar experiencia o lugar…",
  related_title: "También te puede gustar",
  what_to_bring: "Qué llevar",
  wtb_1: "Zapatos cómodos y una botella de agua",
  wtb_2: "Bañador, toalla y protector solar para experiencias de mar",
  wtb_3: "Ropa por capas para trekking y montaña",
  boat_hero_note: "Excursiones privadas • Atardecer • Aperitivo • Experiencias personalizadas",
  boat_hero_sub2: "El mar de Nápoles vivido desde una perspectiva completamente distinta.",
  discover_experience: "Descubrir la experiencia",
  faq_page_title: "Preguntas frecuentes",
  faq_page_sub: "Reservas, pagos, cancelaciones, clima y todo lo que hay que saber.",
  need_help: "¿Necesitas ayuda?",
  booking_info: "Información de reservas",
  cancellation_policy: "Política de cancelación",
  all_faqs: "Todas las FAQ",
  admin_title: "Área de administración",
  admin_denied: "Acceso restringido. Accede con una cuenta de administrador.",
  admin_link: "Panel admin",
  tab_overview: "Resumen",
  tab_requests: "Solicitudes",
  tab_experiences: "Experiencias",
  tab_users: "Usuarios",
  tab_contacts: "Contactos",
  stats_requests: "Solicitudes totales",
  stats_users: "Usuarios registrados",
  stats_experiences: "Experiencias activas",
  stats_favorites: "Guardados",
  change_status: "Cambiar estado",
  featured_label: "Destacada",
  save_label: "Guardar",
  saved_ok: "Guardado",
  price_edit: "Precio (desde)",
  day_title: "Crea tu día en Campania",
  day_sub: "Elige qué quieres vivir: combinamos automáticamente mar, cultura, sabor y naturaleza en un itinerario a medida.",
  day_pick: "¿Qué quieres vivir?",
  day_area: "¿Dónde quieres estar?",
  day_area_all: "En toda Campania",
  day_people: "¿Cuántos?",
  day_generate: "Generar mi itinerario",
  day_itinerary: "Tu itinerario",
  day_morning: "Mañana",
  day_afternoon: "Tarde",
  day_evening: "Noche",
  day_empty: "Selecciona al menos dos dimensiones para generar el itinerario.",
  day_send: "Solicitar este itinerario",
  day_sent_title: "Itinerario solicitado",
  day_sent_sub: "Hemos recibido tu itinerario ideal. Lo convertiremos en una propuesta concreta y te contactaremos.",
  day_per_person: "por persona",
  day_edit: "Editar selección",
  nav_companion: "Companion",
  companion_title: "Flegrea Companion",
  companion_sub: "Tu compañero de viaje: lecturas e historias de los lugares que visitarás, y tus servicios siempre a mano con el apoyo de nuestro equipo.",
  langs_note: "próximamente",
  readings_title: "Lecturas y profundizaciones",
  min_read: "min de lectura",
  back_companion: "Todas las historias",
  your_services: "Tus servicios",
  support_staff: "Soporte del equipo",
  support_title: "¿Necesitas ayuda?",
  support_sub: "Gestiona todo en autonomía — y cuando haga falta, nuestro equipo está a un mensaje.",
  carousel_overline: "El territorio",
  carousel_title: "Campania, de verdad",
  carousel_sub: "Fotografías reales de nuestros tours. Próximamente: grabaciones con dron de los sitios arqueológicos y las salidas en barco.",
  contact_title: "Solicitar información",
  contact_sub: "Simple, rápido, conciso: escríbenos y te respondemos directamente por email.",
  message_label: "Tu mensaje",
  send_message: "Enviar solicitud",
  contact_sent: "Mensaje enviado",
  contact_sent_sub: "¡Gracias! Responderemos en breve a la dirección de email indicada.",
  contact_required: "Completa nombre, email y mensaje.",
  contact_error: "Envío fallido. Inténtalo de nuevo o escríbenos por WhatsApp.",
  contact_privacy_note: "Al enviar aceptas la Política de Privacidad. El mensaje llega directamente a info@flegreaexperience.com.",
  pay_online: "Pagar online",
  pay_online_note: "Pago seguro con Stripe. La disponibilidad queda sujeta a confirmación.",
  payment_processing: "Verificando tu pago…",
  payment_success_title: "Pago realizado",
  payment_success_sub: "¡Gracias! Tu solicitud está confirmada en el pago. Te contactaremos para confirmar disponibilidad y detalles.",
  payment_success_pending_note: "Si completaste el pago, la confirmación puede tardar unos minutos. Para dudas escríbenos por WhatsApp.",
  payment_check_again: "Verificación en curso",
  payment_cancel_title: "Pago cancelado",
  payment_cancel_sub: "No se ha realizado ningún cargo. Puedes reintentarlo cuando quieras o enviar la solicitud sin pago online.",
  nav_all_experiences: "Todas las experiencias",
  nav_gallery: "Galería",
  gallery_title: "Galería",
  gallery_sub: "Todos los lugares de nuestras experiencias, foto a foto: de los volcanes de los Campos Flégreos a las islas, de la Nápoles subterránea a los limones de Sorrento.",
  gallery_videos_title: "El territorio en movimiento",
  gallery_videos_sub: "Imágenes desde el mar y la tierra. Nuevos vídeos — dron y relatos de las experiencias — próximamente.",
  gallery_coming_soon: "Próximamente",
  gallery_photos_title: "Todas las fotos",
  back_home: "Volver al inicio",
  hero_sub: "Tours, excursiones, mar, historia y sabores auténticos en los Campos Flégreos.",
  story_cta: "Descubre la historia",
  seo_home_title: "Flegrea Experience — Tours y Experiencias en los Campos Flégreos",
  seo_home_desc: "Experiencias auténticas en los Campos Flégreos: tours guiados en Pozzuoli, Baia y Bacoli, Lago de Averno y Monte Nuovo, excursiones en barco a Capri, Isquia y Procida.",
  boat_cta_title: "¿Listo para zarpar?",
  boat_cta_sub: "Escríbenos por WhatsApp y planifiquemos tu día en el mar en los Campos Flégreos.",
};
